export default __webpack_public_path__ + "static/media/exhibition_overview_1_en.6b8a83cc.svg";